/* ==========================================================================
   anlass.js — Progressive Enhancement fuer die eigenen Kollektions-Templates
   --------------------------------------------------------------------------
   Portiert aus assets/anlass.js des deutschen Shops (blockhuette.net, Stand
   17.08.2026). Wird nur geladen, wenn layout/theme.liquid den Suffix in seiner
   Liste findet, derzeit also nur auf templates/collection.spare-parts.json.

   Einziger Zweck hier: den Einleitungstext des Hero auf Mobilgeraeten auf N
   Zeilen kuerzen und einen Aufklapp-Button ergaenzen.

   NICHT portiert: die eTrusted-Sternchen-Haelfte des Originals (Platzhalter per
   IntersectionObserver durch <etrusted-widget> ersetzen). Der UK-Shop fuehrt
   kein eTrusted, Bewertungen kommen von Judge.me, und das deutsche Template
   schaltet die Sterne auf dieser Seite ohnehin ab (`show_stars: false`).
   snippets/anlass-product-card.liquid rendert deshalb gar keinen Platzhalter.
   Wer Judge.me-Sterne auf den Karten will, baut das neu und nicht hier nach.

   Bewusst Progressive Enhancement: serverseitig steht der vollstaendige Text
   im HTML. Erst dieses Skript kuerzt ihn visuell. Ohne JavaScript ist der Text
   ungekuerzt lesbar, nie abgeschnitten ohne Moeglichkeit ihn zu oeffnen.
   Crawler und Antwortmaschinen sehen ihn immer vollstaendig, `line-clamp`
   versteckt nur optisch.

   ES5 mit var und ohne Pfeilfunktionen, wie das Original: die Datei laeuft
   ohne Transpilation und ohne Build-Schritt (siehe Build-Kette in CLAUDE.md,
   nur src/theme.js und src/lazysizes.js werden gebaut).
   ========================================================================== */

(function () {
  'use strict';

  var narrow = window.matchMedia('(max-width: 640px)');

  function updateClamp(el) {
    var btn = el.__anlassToggle;
    if (!btn) {
      return;
    }

    if (!narrow.matches) {
      el.setAttribute('data-anlass-clamped', 'false');
      btn.hidden = true;
      return;
    }

    // Vom gekuerzten Zustand aus messen, ob ueberhaupt etwas abgeschnitten wird.
    if (el.getAttribute('data-anlass-clamped') !== 'false' || !el.__anlassOpened) {
      el.setAttribute('data-anlass-clamped', 'true');
      btn.hidden = el.scrollHeight <= el.clientHeight + 1;
    }
  }

  function setupClamp(el) {
    if (el.__anlassToggle) {
      return;
    }

    var lines = parseInt(el.getAttribute('data-anlass-clamp'), 10);
    el.style.setProperty('--anlass-clamp-lines', lines > 0 ? lines : 3);

    var more = el.getAttribute('data-anlass-clamp-more') || 'Show more';
    var less = el.getAttribute('data-anlass-clamp-less') || 'Show less';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'anlass-hero__introToggle';
    btn.textContent = more;
    btn.setAttribute('aria-expanded', 'false');
    btn.hidden = true;

    if (!el.id) {
      el.id = 'anlass-intro-' + Math.round(el.getBoundingClientRect().top) + '-' + el.textContent.length;
    }
    btn.setAttribute('aria-controls', el.id);

    btn.addEventListener('click', function () {
      var isClamped = el.getAttribute('data-anlass-clamped') !== 'false';
      el.setAttribute('data-anlass-clamped', isClamped ? 'false' : 'true');
      el.__anlassOpened = isClamped;
      btn.setAttribute('aria-expanded', isClamped ? 'true' : 'false');
      btn.textContent = isClamped ? less : more;
    });

    el.parentNode.insertBefore(btn, el.nextSibling);
    el.__anlassToggle = btn;
    updateClamp(el);
  }

  /**
   * Bewusst als Funktion mit Wurzel-Parameter statt als einmaliger Durchlauf:
   * Der Theme-Editor tauscht bei jeder Aenderung das Section-DOM aus. Eine beim
   * Laden eingesammelte NodeList zeigt danach auf verworfene Knoten.
   */
  function initClamps(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }
    var targets = root.querySelectorAll('[data-anlass-clamp]');
    for (var i = 0; i < targets.length; i++) {
      setupClamp(targets[i]);
    }
  }

  function refreshClamps() {
    var targets = document.querySelectorAll('[data-anlass-clamp]');
    for (var i = 0; i < targets.length; i++) {
      updateClamp(targets[i]);
    }
  }

  if (typeof narrow.addEventListener === 'function') {
    narrow.addEventListener('change', refreshClamps);
  } else if (typeof narrow.addListener === 'function') {
    narrow.addListener(refreshClamps);
  }

  initClamps(document);

  document.addEventListener('shopify:section:load', function (event) {
    initClamps(event.target);
  });
})();
